import { Component, Element, h, Host, Prop, Watch } from '@stencil/core';

@Component({
  tag: 'fds-nav-list-items',
  styleUrl: 'styles/nav-list-items.scss',
  shadow: true,
})
export class NavListItems {
  @Element() el!: HTMLFdsNavListItemsElement;

  /**
   * If true, a frame/border will be rendered around the component
   */
  @Prop() bordered = false;

  @Watch('bordered')
  borderedChanged() {
    this.initNavListItems();
  }

  componentWillLoad() {
    this.initNavListItems();
  }

  private initNavListItems() {
    const navListItems = this.getNavListItems();
    const { length: navListItemsLength } = navListItems;

    for (const [index, item] of navListItems.entries()) {
      item.bordered = false;
      item.first = false;
      item.last = false;
      item.hideTopBorder = true;

      if (this.bordered) {
        item.bordered = true;
      }

      if (navListItemsLength === 1) {
        item.first = true;
        item.last = true;
        item.hideTopBorder = false;
      } else if (index === 0) {
        item.first = true;
        item.hideTopBorder = false;
      } else if (index === navListItemsLength - 1) {
        item.last = true;
      }
    }
  }

  private getNavListItems() {
    return [...this.el.querySelectorAll('fds-nav-list-item')];
  }

  render() {
    return (
      <Host>
        <nav>
          <ul role="menu" class={`fds-nav-list-items ${this.bordered ? 'fds-nav-list-items--bordered' : ''}`}>
            <slot />
          </ul>
        </nav>
      </Host>
    );
  }
}
